var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVector(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 13,
    viewBox: "0 0 6 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.229515 12.2308C0.535534 12.5826 1.03169 12.5826 1.33771 12.2308L5.77048 7.13622C6.0765 6.78451 6.0765 6.21427 5.77048 5.86256C5.46446 5.51085 4.96831 5.51085 4.66229 5.86256L0.229514 10.9572C-0.0765049 11.3089 -0.0765047 11.8791 0.229515 12.2308Z",
    fill: "#B31B34"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.77049 7.13714C6.07651 6.78543 6.07651 6.21519 5.77049 5.86348L1.33771 0.768856C1.03169 0.417145 0.535536 0.417145 0.229517 0.768856C-0.0765022 1.12057 -0.0765021 1.6908 0.229517 2.04251L4.66229 7.13714C4.96831 7.48885 5.46447 7.48885 5.77049 7.13714Z",
    fill: "#B31B34"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/vector.9d5bc819de417176d40763d9adb10913.svg";
export { ForwardRef as ReactComponent };